import axios from "axios";
import { db } from "../db/indexeddb"
import { API_ENDPOINT } from "../../services/api/resources";

export class RCRepository{
    async getRCsFromCache(){
        const data= await db.rateContract.toArray()
        return data.map((d)=>d.data)
    }

 async saveRCsToCache(rcs = [], clearOld = false) {
    if (!rcs.length) return;

    await db.transaction("rw", db.rateContract, async () => {
      if (clearOld) {
        await db.rateContract.clear();
      }

      for (const rc of rcs) {
        if (!rc?.rc_token) continue;

        await db.rateContract.put({
          rc_token: rc.rc_token,
          rc_number: rc.rc_number,
          data: rc,
          lastSynced: Date.now(),
        });
      }
    });

    console.log("RC cached:", rcs.length);
  }

   async syncRCsFromAPI(authToken,buyerToken){
    if(!navigator.onLine){
        return this.getRCsFromCache()
    }

    const response =await axios.post(
        API_ENDPOINT.get_combine_rcList,
        {buyer_token:buyerToken},
        {
        headers: {
          Authorization: `Token ${authToken}`,
          "Content-Type": "application/json",
        },
      }
    )

    const rcList=response.data||[]

    await this.saveRCsToCache(rcList,true)

    return rcList;
   }

async syncOfflinePO(authToken) {
  if (!navigator.onLine) {
    console.log("Still offline");
    return;
  }

  const queued = await db.offlineRcPO.toArray();
  console.log("Queued PO count:", queued.length);

  for (const po of queued) {
    try {
      console.log("Syncing PO:", po.id);

      await axios.post(
        API_ENDPOINT.convert_rate_contract_to_po,
        po.payload,
        {
          headers: {
            Authorization: `Token ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      await db.offlineRcPO.delete(po.id);
      console.log("Deleted synced PO:", po.id);

    } catch (err) {
      console.error("PO sync failed:", err);
    }
  }
}



}

export const rcRepository = new RCRepository();



